import ChildrenPrivacy from './index.vue'
export default ChildrenPrivacy